import * as React from 'react';
import { connect, Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { OfflineManagerState } from '../../OfflineManager/reducer';
import { isSynchronizationInProgress } from '../../../utils/synchronization';
import { signOut } from '../actions';

interface PendingLogoutAfterSyncWatcherProps {
	pendingLogoutAfterSync: boolean;
	offlineManager: OfflineManagerState;
	dispatch: Dispatch<StoreState>;
}

class PendingLogoutAfterSyncWatcher extends React.Component<PendingLogoutAfterSyncWatcherProps> {
	componentDidMount() {
		this.tryLogoutWhenSyncComplete();
	}

	componentDidUpdate(prevProps: PendingLogoutAfterSyncWatcherProps) {
		if (!this.props.pendingLogoutAfterSync) {
			return;
		}

		const wasSyncing = isSynchronizationInProgress(prevProps.offlineManager);
		const isSyncing = isSynchronizationInProgress(this.props.offlineManager);

		if (wasSyncing && !isSyncing) {
			this.tryLogoutWhenSyncComplete();
		}
	}

	tryLogoutWhenSyncComplete = () => {
		const { pendingLogoutAfterSync, offlineManager, dispatch } = this.props;

		if (pendingLogoutAfterSync && !isSynchronizationInProgress(offlineManager)) {
			dispatch(signOut());
		}
	}

	render() {
		return null;
	}
}

const mapStateToProps = (state: StoreState) => {
	const { multiAppAuthenticationInfos: { pendingLogoutAfterSync }, offlineManager } = state;
	return { pendingLogoutAfterSync, offlineManager };
};

export default connect(mapStateToProps)(PendingLogoutAfterSyncWatcher);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/PendingLogoutAfterSyncWatcher/index.tsx